// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import tableOfContents from "./tableOfContents";
import copyLink from "./copyLink";
import demoModal from "./demoModal";
import stickyCta from "./stickyCta";


// Call the menu and infinite scroll functions
menuOpen();
infiniteScroll();
tableOfContents();
copyLink();
demoModal();
stickyCta();
